import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import securityApi from "apis/eduidSecurity";
import { EduIDButton } from "components/Common/EduIDButton";
import { IDENTITY_PATH } from "helperFunctions/paths";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { ShowAndHideButton } from "./ShowAndHideButton";
function RenderShowHideNin({ nin, allowDelete }) {
    const [showFullNin, setShowFullNin] = useState(false); // show the last four digits of the NIN or not
    const [removeNin] = securityApi.useLazyRemoveNinQuery();
    if (!nin) {
        // NinDisplay won't render this component if nin is undefined, but we need to tell TypeScript that
        return null;
    }
    const handleDelete = function () {
        if (allowDelete && nin) {
            removeNin({ nin: nin.number });
        }
    };
    return (_jsxs("div", { className: "display-nin-show-hide", children: [_jsx("div", { className: `display-data ${nin.verified ? "verified" : "unverified"}`, children: showFullNin ? nin.number : nin.number.replace(/.{4}$/, "****") }), _jsx(ShowAndHideButton, { isShown: showFullNin, onClick: () => setShowFullNin(!showFullNin) }), allowDelete && !nin.verified && (_jsx(EduIDButton, { buttonstyle: "close sm", onClick: handleDelete }))] }));
}
export function NinDisplay({ nin, allowDelete }) {
    return (_jsx("div", { className: "profile-grid-cell", children: nin ? (_jsx(RenderShowHideNin, { nin: nin, allowDelete: allowDelete })) : (_jsx(Link, { to: IDENTITY_PATH, className: "display-data unverified", children: _jsx(FormattedMessage, { id: "ninDisplay.link", defaultMessage: "add id number", description: "NIN display link text" }) })) }));
}
